module.exports = __webpack_public_path__ + "static/img/log_blue.594faff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/log_blue.svg
// module id = vGxU
// module chunks = 1